/* eslint-disable */
import { take, put } from "redux-saga/effects";
import { httpPost } from "../../Utils/apis/apis";
import { previousUploadActionTypes } from "../actions/actionTypes";
import * as previousUploadActions from "../actions/previousUploadActions";
import { setToast } from "../actions/toastActions";
import { toastType, toastSeverity } from "../../Utils/config/toastConfig";
import { message } from "../../Utils/config/messages";
import {
  fileListWithDisplayName,
  getDocumentListPath,
} from "../../components/Factory/Molecules/Common/Renderers/Views/PreviousTemplate/previousUpload.helper";
import { getSubDomain } from "../../components/Factory/Pages/Common/User Management/HelperFunctions";
export function* getPreviousUploadSaga() {
  while (true) {
    const action = yield take(previousUploadActionTypes.GET_PREVIOUS_UPLOAD);
    const { crmId, pageUrl, container, directory, filePrefix } = action.payload;

    try {
      const url = `${process.env.DOCUMENT_HELPER}`;
      const subdomain = getSubDomain();
      let documentName;
      documentName = crmId === 0 ? pageUrl : crmId;
      documentName = directory ? directory : documentName;
      documentName = getDocumentListPath(filePrefix, documentName);
      let header = {
        filename: documentName,
        type: container ? container : "generic",
        "file-operation": "blob-items",
        "process-file": "no",
        "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
        subdomain: subdomain,
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      const res = yield httpPost(
        url,
        {
          method: "GET",
        },
        {headers: header}
      );
      let filesList = fileListWithDisplayName(res);
      yield put(
        previousUploadActions.getPreviousUploadSucceeded({
          data: filesList,
        })
      );
    } catch (e) {

      setToast({
        type: toastType.PREVIOUS_UPLOAD_SAGA,
        severity: toastSeverity.ERROR,
        message: message.PREVIOUS_UPLOAD_SAGA,
        status: true,
      });
      previousUploadActions.getPreviousUploadFailed({
        errorCode: "",
        message: "",
        status: false,
      });
    }
  }
}
